import { csrfToken } from './csrf'

// 界面双语。
//
// **文案就地写两份：t('中文', 'English')**，不建 key → 字典。原因：
// 前端有两百多个文件、三千多条文案，按 key 抽字典要给每条起名，改一句
// 中文还得去另一个文件找对应的英文；两份并排写，改的时候一眼看得见另一份。
//
// t 是泛型，JSX 也能传：t(<>去 <Link>设置</Link></>, <>Go to <Link>Settings</Link></>)。
// 插值直接用模板字符串：t(`共 ${n} 条`, `${n} items`)。
//
// **语言在模块加载时就定下来**，读服务端渲染的 <html lang>（Web::BaseController
// #current_locale）。所以模块顶层的常量里调 t 也是对的 —— 代价是换语言要整页
// 刷新（setLocale），这正是故意的：不刷新的话，那些常量会停在旧语言上。
export type Locale = 'zh' | 'en'

export const LOCALE: Locale =
  typeof document !== 'undefined' && document.documentElement.lang.toLowerCase().startsWith('en') ? 'en' : 'zh'

export const isEn = LOCALE === 'en'

export function t<T>(zh: T, en: T): T {
  return isEn ? en : zh
}

// 给 Intl / toLocaleString / FullCalendar 这类要 BCP 47 标签的地方。
export const INTL_LOCALE = isEn ? 'en-US' : 'zh-CN'

// 写 cookie（登录的人也写进 UserSetting），然后整页刷新。见 Web::LocalesController。
export async function setLocale(next: Locale): Promise<void> {
  if (next === LOCALE) return
  const res = await fetch('/locale', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
    body: JSON.stringify({ locale: next }),
  })
  if (!res.ok) throw new Error(`PATCH /locale ${res.status}`)
  window.location.reload()
}
